var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgOrderLink = function SvgOrderLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.182 13.931L.687 15.63c-.3.07-.63-.192-.628-.499V.87C.057.563.387.3.687.37l7.495 1.698c.223.052.395.27.394.498v2.377a.53.53 0 0 1-.511.517.53.53 0 0 1-.511-.517V2.976L1.08 1.512v12.976l6.473-1.464v-1.968a.53.53 0 0 1 .51-.517.53.53 0 0 1 .512.517v2.376a.536.536 0 0 1-.394.5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#333",
    strokeWidth: 0.5,
    d: "M3.76 8.746h7.868l-2.13 2.11a.296.296 0 0 0 0 .428.313.313 0 0 0 .436 0l2.864-2.813-2.864-2.818a.313.313 0 0 0-.436 0 .296.296 0 0 0 0 .428l2.13 2.11H3.76a.298.298 0 0 0-.292.137.302.302 0 0 0 0 .324.298.298 0 0 0 .292.136v-.042z"
  }))));
};

export default __webpack_public_path__ + "static/media/order-link.8c10efce.svg";
export { SvgOrderLink as ReactComponent };